export default __webpack_public_path__ + "static/media/loading.9df3b981.gif";